module.exports = __webpack_public_path__ + "img/estamp.251ec10f.jpg";